export default "__VITE_ASSET__cdea3ca6__"